export default __webpack_public_path__ + "static/media/premium-content.b742ebeb.png";